import React from 'react';
const bonuses = [{
  emoji: '⚽',
  title: 'Specifik Opvarmningsguide',
  desc: 'Rutiner til aktivering og skadesforebyggelse.'
}, {
  emoji: '📅',
  title: 'Årshjul Express',
  desc: 'En færdig køreplan til at organisere din sæson og kampe.'
}, {
  emoji: '✅',
  title: 'Evalueringsskemaer',
  desc: 'Selvevaluering så dine spillere kan måle deres fremskridt.'
}, {
  emoji: '🥗',
  title: 'Basal Ernæringsguide',
  desc: 'Hvad man skal spise før og efter kamp.'
}, {
  emoji: '🏆',
  title: 'Professionelt Certifikat',
  desc: 'Bevis på din træning i metoden.'
}, {
  emoji: '📝',
  title: 'Standard Husorden',
  desc: 'Dokument klar til underskrift for at professionalisere holdet.'
}];
export function BonusSection() {
  return <section className="w-full bg-bg-main py-20 px-4" data-id="element-14">
      <div className="max-w-4xl mx-auto" data-id="element-15">
        <div className="text-center mb-14" data-id="element-16">
          <span className="inline-block text-secondary font-bold text-sm tracking-widest uppercase mb-3" data-id="element-17">
            🔥 6 Bonusser Inkluderet
          </span>
          <h2 className="text-3xl sm:text-5xl font-black text-text-main mb-3 tracking-tight" data-id="element-18">
            Tilføj disse ekstra{' '}
            <span className="text-secondary" data-id="element-19">uden at betale mere</span>
          </h2>
          <p className="text-text-sec text-base sm:text-lg font-medium" data-id="element-20">
            Værdi:{' '}
            <span className="text-badge-red font-black line-through" data-id="element-21">
              295 DKK
            </span>{' '}
            — GRATIS i dag
          </p>
        </div>

        <div className="space-y-4" data-id="element-22">
          {bonuses.map((bonus, i) => <div key={i} className="bg-bg-alt/80 backdrop-blur-sm rounded-2xl border border-border-light p-5 sm:p-6 flex flex-col sm:flex-row items-start sm:items-center gap-4 sm:gap-5 transition-all hover:-translate-y-1 hover:border-secondary/30 hover:shadow-[0_10px_30px_rgba(245,158,11,0.1)] group" data-id="element-23">
              <div className="w-14 h-14 rounded-xl bg-gradient-to-br from-secondary/20 to-secondary/5 border border-secondary/20 flex items-center justify-center flex-shrink-0 text-2xl shadow-inner group-hover:from-secondary/30 transition-colors" data-id="element-24">
                {bonus.emoji}
              </div>

              <div className="flex-1 min-w-0" data-id="element-25">
                <h4 className="text-text-main font-bold text-lg sm:text-xl mb-0.5" data-id="element-26">
                  {bonus.title}
                </h4>
                <p className="text-text-sec text-sm sm:text-base leading-relaxed" data-id="element-27">
                  {bonus.desc}
                </p>
              </div>

              <span className="bg-secondary/10 text-secondary border border-secondary/20 px-3 py-1.5 rounded-lg font-black text-sm sm:text-base flex-shrink-0 shadow-[0_0_10px_rgba(245,158,11,0.2)]" data-id="element-28">
                GRATUIT
              </span>
            </div>)}
        </div>
      </div>
    </section>;
}